export const firebaseConfig = {
    apiKey: 'AIzaSyBxYRO0esh6j8jp2PFAvOYHnzauBqbXebg',
    authDomain: 'taurin190com-1baea.firebaseio.com',
    databaseURL: 'https://taurin190com-1baea.firebaseio.com',
    projectId: 'taurin190com-1baea',
    storageBucket: 'taurin190com-1baea.firebaseio.com',
    messagingSenderId: '12345'
}